$(function() {
    function checkPhoneFormat(phoneRpl, element) {
        var _this = element;
      var regex=/^0[0-9]{10}$/;
      if (!phoneRpl.match(regex) || phoneRpl.length != 11 ) {
        if($('#error-for-phone').length > 0) {
          $('#error-for-phone span').remove();
          $('#error-for-phone').append('<span>. Phone Number format to contain 11 digits</span>');
        }else {
          $(_this).parent().append('<p class="field__message field__message--error" id="error-for-phone">Enter a valid phone number<span>. Phone Number format to contain 11 digits</span></p>');
        }
        $(_this).parents('form').addClass('field--error');
        event.preventDefault();
        return false;
      }else {
          $(_this).parents('form').removeClass('field--error');
      }
  }

  if($('.product-options .selector-wrapper').length > 0) {
      $('.product-options .single-option-selector option').each(function() {
          var valueOpt = $(this).val();
          var wapperCLaction = $(this).parents('.product-options');
          var dataSlQty = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-quantity');
          var dataVariantId = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-variant-id');
          if($('.list.collection-list').length > 0) {
            var dataPrice = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-price');
            var dataCompareAtPrice = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-compare_at_price');
            var dataPriceSave = $(wapperCLaction).find('.product-select option[data-title="'+ valueOpt +'"]').attr('data-price_save');
            $(this).attr('data-price',dataPrice);
            $(this).attr('data-compare_at_price',dataCompareAtPrice);
            $(this).attr('data-price_save',dataPriceSave);
          }
          $(this).attr('data-quantity',dataSlQty);
          $(this).attr('data-variant',dataVariantId);
      });
  }
  if($('.product-wrap #quantity').length > 0) {
      var input = $('.product-wrap #quantity');
      var dataQuantity = $(input).attr('data-quantity');
      input.keyup(function() {
          var newResult = parseFloat(input.val());
          if($('.product-options .selector-wrapper').length > 0) {
              dataQuantity = $('.product-options .single-option-selector option:selected').attr('data-quantity');
          }
          if(newResult > dataQuantity) {
              input.val(1);
              alert('The quantity being add to cart exceed the actual inventory');
          }
      });
  }

  $('body').on('click', '#create_customer .cta-container .button', function() {
      var x = document.getElementById("agree").required;
  });

    if($('.customer-addresses form input[name="address[phone]"]').length > 0) {
        var phone_regex = '0[0-9]{10}';
        $('.customer-addresses form input[name="address[phone]"]').inputmask({
          regex: "^" + phone_regex +"$"
        });

        $('.customer-addresses form input[name="address[phone]"]').on("keyup", function() {
            var phoneVal = $(this).val();
            var phoneRpl = phoneVal.replace(" ", "");
            checkPhoneFormat(phoneRpl,this);
        });
        
        $('.customer-addresses input[type="submit"]').click(function(){
            var inputPhone = $(this).parents('form').find('input[name="address[phone]"]');
            var phoneVal = $(inputPhone).val();
            var phoneRpl = phoneVal.replace(" ", "");
            checkPhoneFormat(phoneRpl,'.customer-addresses form input[name="address[phone]"');
        });
    }
    
    if($('#editAddress').length > 0) {
        var addresssID = $('#accountAddress').attr('data-addressID');
        $('#editAddress').click(function() {
            $('.account-detail').addClass('show');
        });
        $('.cancel-edit').click(function() {
            $('.account-detail').removeClass('show');
            return false;
        });
        
        $('#submitUpdate').click(function(){
            var phoneVal = $('.customer-addresses form input[name="address[phone]"]').val();
            var phoneRpl = phoneVal.replace(" ", "");
            
            var statusForm = checkPhoneFormat(phoneRpl,'.customer-addresses form input[name="address[phone]"');
            if(statusForm !== false) {
                var data = $('#address_form_'+ addresssID).serialize();
                var urlAdddress = '/account/addresses/'+addresssID;
                $.ajax({
                    type: "post",
                    url: urlAdddress,
                    data: data, 
                    beforeSend: function() {
                        $('.account-detail').addClass('loadding');
                    },
                    success: function(msg) {
                        location.reload();
                    },
                    error: function(xhr, text) {
                    alert('something error');
                    }
                });
            }            
        });
    }
    
    // Filter collection
    if($('.filter-sidebar').length > 0) {
        $('.filter-sidebar .block-title h3').click(function(){
//             var dataAttTitleFilter = $(this).attr("data-content");
//             var checkSSFilter = sessionStorage.getItem(dataAttTitleFilter);
//             if(checkSSFilter === null) {
//                 sessionStorage.setItem(dataAttTitleFilter, '1');
//             }else {
//                 if(checkSSFilter == '1') {
//                 sessionStorage.setItem(dataAttTitleFilter, '0');
//                 }else {
//                 sessionStorage.setItem(dataAttTitleFilter, '1');
//                 }
//             }
            $(this).parents('.block').toggleClass('show');
        });
      
      // if input checked => show item
      $( '.filter-sidebar > .block' ).each(function( index ) {
        // get item
        var listItemFilter = $(this).find('.block-content ul li');        
        $(listItemFilter).each(function( index ) {
          // Get input
          var inputCheck = $(this).find('input[type=checkbox]');
          if(inputCheck.is(':checked') == true) {
            $(this).parents('.block').addClass('show');
          	return false;
          }
        });
      });
    }

    // Collection action add to cart
    $('.cl-product-action .icon-plus').click(function() {
      	var wrapAction = $(this).parents('.cl-product-action');
      	var inputQt = $(this).parents('.cl-product-action').find('input.quantity');
      	var dataQuantity = 1;
      	// view detail
      	if($('.product-wrap .product-details').length > 0) {
          if($(wrapAction).find('.single-option-selector').length > 0){
          	dataQuantity = $(wrapAction).find('.product-select[name="id"] option:selected').attr('data-quantity');
          }else {
          	dataQuantity = $(wrapAction).find('input.quantity').attr('data-quantity');
          }          
        }else {
          // view list
          if($(wrapAction).find('.single-option-selector').length > 0) {
            dataQuantity = $(wrapAction).find('.single-option-selector option:selected').attr('data-quantity');
          }else {
          	dataQuantity = $(wrapAction).find('input.quantity').attr('data-quantity');
          }
        }
      	
        var inputQtVal = parseFloat($(inputQt).val());
        if((inputQtVal + 1) > dataQuantity) {
            alert('The quantity being add to cart exceed the actual inventory');
        }else {
            $(inputQt).val(inputQtVal + 1);
        }
    });
    $('.cl-product-action .icon-minus').click(function() {
        var inputQt = $(this).parents('.cl-product-action').find('input.quantity');
        var inputQtVal = parseFloat($(inputQt).val());
        if(inputQtVal > 1) {
            $(inputQt).val(inputQtVal - 1);
        }
    });

    // Change variant page collection
    $('.single-option-selector').change(function(){
      if($('.product-wrap .product-details').length > 0) {
        
      }else {
        // get wrapitem and dom currentPrice
        var wrapItem = $(this).parents('.list-item');
        var currentPrice = $(wrapItem).find('.price > .money:not(.original)');
        // get prices of option seleted
        var dataPrice = $('option:selected', this).attr('data-price');
      	
        var dataComparePrice = $('option:selected', this).attr('data-compare_at_price');
        
        // parseFloat prices to compare
        var initdataPrice = parseFloat(dataPrice.replace(/[^0-9]/g,''));
        var initdataPriceCompare = parseFloat(dataComparePrice.replace(/[^0-9]/g,''));
        // compare prices
        if(initdataPriceCompare > initdataPrice) {            
            var priceSave = $('option:selected', this).attr('data-price_save');
            $(wrapItem).removeClass('no_compare');
            if($(wrapItem).find('.price .original').length > 0) {
                $(wrapItem).find('.price .original').text(dataComparePrice);
            }else {
                // $(wrapItem).find('.list-meta > .price').append('<span class="class="original money"">'+ dataComparePrice +'</span><span class="saving">saving</span><span class="saving-result money">'+ priceSave +'</span>');
            }
            if($(wrapItem).find('.saving-result.money').length > 0) {
                $(wrapItem).find('.saving-result.money').text(priceSave);
            }else {
                if($(wrapItem).find('.list-meta .saving').length > 0) {
                    $(wrapItem).find('.list-meta .saving').append('saving <span class="saving-result money"> '+ priceSave +'</span>');
                }
            }
        }else {
            $(wrapItem).addClass('no_compare');
        }
        $(currentPrice).text(dataPrice);

        var dataVariant = $('option:selected', this).attr('data-variant');
        if ($(wrapItem).find('img.list-image-'+dataVariant).length > 0) {
          $(wrapItem).find('img.list-image').addClass('hidden');
          $(wrapItem).find('img.list-image-'+dataVariant).removeClass('hidden');
        } else {
          $(wrapItem).find('img.list-image:first-child').removeClass('hidden');
        }
      }
        
    });
  
  function updateURLSearch(val) {
    // var arr = val.split(" ");
    // var query = '';
    // $.each(arr,function(index,value){
    //   query += value+"+";
    // });
    // var href = "/search/?q="+query+"-invisible&&type=product";
    var href = "/search/?q="+val+"*&type=product";
    $(location).attr('href', href);
  }
  
  // Search
  $('.header-search-input').on('keypress',function(e) {
    if(e.which == 13) {
      e.preventDefault();
      var input_search = $(this).val();
      updateURLSearch(input_search);
    }
  });
  
  $("#SearchResultSubmit").click(function(e) {
    e.preventDefault();
    var input_search = $('#SearchInput').val();
    updateURLSearch(input_search);
  });
  
  // update contact form agree
  $(".contact-form #agree").click(function(){
    if($(this).is(":checked")) {
      $(".contact-form .contact-form-button").prop('disabled', false);
    }else {
    	$(".contact-form .contact-form-button").prop('disabled', true);
    }
  });

});


$(window).load(function() {
    // cookie    
    var windowWidth = $( window ).width();
    // if(windowWidth <= 720) {
    //     var footerOfTop = $('.footer-wrapper').offset().top;    
    //     $( window ).scroll(function() {
    //         var scrollPosition = $(window).scrollTop();
    //         if($('.cc-theme-block').length > 0) {
    //             if(scrollPosition >= footerOfTop) {
    //                     $('.cc-theme-block').addClass('ps-relative');
    //             }else {
    //                 $('.cc-theme-block').removeClass('ps-relative');
    //             }
    //         }      
    //     });
    // }
  
  
  // CartPage
  function checkCartPageDisscount() {
    // Look for Advance Product Options parameters.
    var options = $('.saso-cart-total').is(':empty');
    console.log(options);
    if (options && (!checkCartPageDisscount.retry || checkCartPageDisscount.retry <= 100)) {      
      checkCartPageDisscount.retry = checkCartPageDisscount.retry ? checkCartPageDisscount.retry + 1 : 1;
      setTimeout(checkCartPageDisscount, 100);
    }
    else if (!options) {
      if($('.saso-cart-total .saso-use-discount-instead-container').length > 0) {
        $('.saso-cart-total').addClass('title_hidden');
      }else {
        $('.saso-cart-total').addClass('title_show');
      }      
    }
  }
  if($('.saso-cart-total').length > 0) {
  	checkCartPageDisscount();
  }
  
   // PAGE GLOBAL NETWORK
  $('.page-network-container .country-container .country-name').click(function(){
    var liParent      = $(this).parents('li');
    var offOverlay    = $(liParent).find('.offices-overlay');
    var liOffsetLeft  = $(liParent).offset().left;
    var warpOffsetLeft = $('.page-network-container').offset().left;
    var leftOverlay   = 0 - (liOffsetLeft - warpOffsetLeft);
    if(offOverlay.hasClass('active')) {
      offOverlay.removeClass('active');
      $(offOverlay).slideUp();
    }else {
      $('.offices-overlay').hide();
      $('.country-container li .offices-overlay').removeClass('active');
      $(offOverlay).css("left",leftOverlay);
      $(offOverlay).slideDown();
      $(offOverlay).addClass('active');
    }
  });
  $('.offices-overlay a.close').click(function() {
    $('.offices-overlay').hide();
    $('.offices-overlay').removeClass('active');
  });
  // END GLOBAL NETWORK
  
  // Page Career
  $('.Careercontent .CareerNav a').click(function(e){
   
    e.preventDefault();
    let idNav = $(this).attr('href');
    let offsetNav = $(idNav).offset().top;
    let widthWindow = $(window).width();
     
    if($('.header.sticky-header').length > 0 && widthWindow > 767) {
      var heightHeader = $('.header.sticky-header').height();
      offsetNav = offsetNav - heightHeader;
    }
    $('html, body').animate({
      scrollTop: offsetNav
    }, 1000);
  });
  // End Page Career

  // Page Career
  $('#awards-btn > li').on('click', function(){
		awardsLiIndex = $(this).index();
		$('#awards-btn > li').removeClass('active');
		$('#awards-box > li').removeClass('active');
		$(this).addClass('active');
		$('#awards-box > li:eq('+ awardsLiIndex +')').addClass('active');
	});
  // End Page Career
  
});
